import { render, staticRenderFns } from "./UserbookSubjectDetail.vue?vue&type=template&id=2c157540&scoped=true"
import script from "./UserbookSubjectDetail.vue?vue&type=script&lang=js"
export * from "./UserbookSubjectDetail.vue?vue&type=script&lang=js"
import style0 from "./UserbookSubjectDetail.vue?vue&type=style&index=0&id=2c157540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c157540",
  null
  
)

export default component.exports